import { RoleType } from '../utilities/constants';

export interface IRole {
    Type: RoleType;
}

export class Role implements IRole {
    public Type: RoleType;
}